// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__2pzUB","content":"GlobalSearch_content__2ABJF"};